module.exports = __webpack_public_path__ + "static/media/success-check.d949e14e.gif";